import { souscriptionSchema } from "./souscription";
import { createZodDto } from "nestjs-zod/dto";

const updateSouscriptionSchema = souscriptionSchema
  .pick({
    code: true,
    paymentId: true,
    userId: true,
    valid_from: true,
    valid_to: true,
    is_active: true,
  })
  .partial();

export class UpdateSouscriptionDto extends createZodDto(updateSouscriptionSchema) {}
